import { createUaOfferingCatalog } from "@constructorfleet/ua-offering";

export const CO_UA_OFFERING_ID = "co-ua-notifications" as const;

export const uaOfferingCatalog = createUaOfferingCatalog({
  id: CO_UA_OFFERING_ID,
  name: "UA Notifications",
  stateCode: "CO",
  stateName: "Colorado",
  marketing: {
    summary: "Checks your daily call-in line and texts you the result before your window closes.",
    description:
      "We find the right line for your state and jurisdiction, check it every day, " +
      "and send you a text with your result — so you always know where you stand.",
    primaryCtaLabel: "Get started",
    tagline: "Know if you need to report — before your window closes.",
    highlights: [
      "Daily automated checks of your call-in line",
      "The right line for your state and jurisdiction, found for you",
      "A text with your result every day",
      "A clear, timestamped record of every check",
    ],
  },
  pricing: {
    price: 1500,
    billingModel: "flat",
    interval: "month",
  },
});

export default uaOfferingCatalog;
